// Phase 83z.61 — Referee sync bootstrap
// Mounted once at the App level. Starts the global sync engine on
// mount (so leftover events from a previous session start retrying
// immediately on app boot — Q9 behaviour) and renders the offline
// banner whenever the current route is under `/referee/*`.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { startSyncEngine } from "../../lib/refereeSyncEngine";
import RefereeOfflineBanner from "./RefereeOfflineBanner";

export default function RefereeSyncBootstrap() {
  const { pathname } = useLocation();
  useEffect(() => {
    startSyncEngine();
  }, []);
  if (!pathname.startsWith("/referee")) return null;
  return <RefereeOfflineBanner />;
}
